// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/compiled-styles." + {"2052":"c7aa0b66f50800500f18","5439":"63cbae8280cb18a1e31c"}[chunkId] + ".css";
};